import React, { useMemo } from "react";
import classNames from "classnames";
import stylesLess from "./xt.module.less";
import Nav, { GlobalHeader, SiteFooter } from "@xt/Nav";
import AuthMobileNav from "./Nav";
import Foot from "@xt/Foot";
import { Platform } from "@xt/xtbase";
import useIsDesktop from "@/hooks/useIsDesktop";
import SpikexPcBackdrop from "./SpikexPcBackdrop";

/**
 * 账户站布局：>768px 为 PC（GlobalHeader + Montserrat + 无 BottomBar）；
 * ≤768px 沿用 H5 BottomBar，或 auth 页仅 logo+语言顶栏。
 *
 * mobileNav:
 *   - bottomBar: @xt/Nav + BottomBar（默认）
 *   - logoLang: 旧 Layout/Nav（logo + 语言），无底部导航
 *   - none: 移动端不展示导航
 */
export default function Layout({
  children,
  isShowNav = true,
  isShowFoot = true,
  style = {},
  /** PC 端是否展示 GlobalHeader（账户子页可关移动端 nav 但仍要 PC 顶栏） */
  showPcHeader = true,
  /** PC：对齐 spikex-ai-web 的 SiteFooter（替代旧 Foot） */
  useSiteFooter = false,
  /** PC 账户页：左侧菜单固定，仅右侧内容区滚动 */
  accountDesktopSplit = false,
  /** 移动端导航形态 */
  mobileNav = "bottomBar",
}) {
  const { isDesktop, isReady } = useIsDesktop();

  const showNav = !Platform.isInApp() && isShowNav !== false;
  const showFoot = !Platform.isInApp() && isShowFoot !== false;
  const isDesktopNav = isReady && isDesktop && showPcHeader && !Platform.isInApp();
  const isMobileViewport = !isReady || !isDesktop;
  const useLogoLangNav = showNav && isMobileViewport && !isDesktopNav && mobileNav === "logoLang";
  const useBottomBarNav = showNav && isMobileViewport && !isDesktopNav && mobileNav === "bottomBar";
  const hasBottomBar = useBottomBarNav;

  const styles = useMemo(() => {
    const base = { ...style };
    if (hasBottomBar) {
      base.paddingBottom = "calc(60px + env(safe-area-inset-bottom, 0px))";
    }
    return base;
  }, [style, hasBottomBar]);

  const renderNav = () => {
    if (isDesktopNav) {
      return <GlobalHeader mode="fixed" hiddenLangKeys={[]} />;
    }
    if (useLogoLangNav) {
      return <AuthMobileNav />;
    }
    if (useBottomBarNav) {
      return <Nav mode="fixed" bgColor="#181a20" bottomBar />;
    }
    return null;
  };

  const mainClass = classNames(stylesLess.main, {
    [stylesLess.mainFixedNavDesktop]: isDesktopNav,
    [stylesLess.mainFixedNav]: useBottomBarNav,
    [stylesLess.mainNoNav]: !isDesktopNav && !useBottomBarNav && !useLogoLangNav,
  });

  return (
    <div
      className={classNames(stylesLess.page, isDesktopNav && stylesLess.pageSpikexFont, accountDesktopSplit && isDesktopNav && stylesLess.pageAccountDesktopSplit)}
      style={styles}
    >
      {isDesktopNav ? <SpikexPcBackdrop /> : null}
      <div className={stylesLess.pageInner}>
        {renderNav()}
        <div className={mainClass}>{children}</div>
        {showFoot ? (useSiteFooter && isDesktopNav ? <SiteFooter /> : <Foot />) : null}
      </div>
    </div>
  );
}
